import { LEFT, RIGHT } from "../core/constants";

import Box from "../components/Box";
import BoxWithGutter from "../components/BoxWithGutter";
import CategoryPromo from "../components/CategoryPromo";
import Head from "next/head";
import LatestDrop from "../components/LatestDrop";
import Layout from "./Layout";
import Line from "../components/Line";
import Metatags from "./Metatags";
import PageContentBrand from "../components/PageContentBrand";
import PromoBlock from "../components/PromoBlock";
import Why from "../components/Why";
import YouTubePlayer from "./YouTubePlayer";
import { MENSWEAR_SLUG, WOMENSWEAR_SLUG } from "../core/urls";

export default function BrandHomepage({
  brand,
  navItems,
  brandMenuData,
  globalData,
  latestDrop,
}) {
  const categoryPromos = brand.rootCategoryPromos.filter((rootCategory) => {
    return rootCategory.products.length > 0;
  });

  return (
    <Layout brand={brand} navItems={navItems} globalData={globalData}>
      <Head>
        <title>{brand.name} x Reskinned</title>
      </Head>
      {brand.active && (
        <Metatags
          metaTitle={brand.metaTitle ? brand.metaTitle : ""}
          metaDescription={brand.metaDescription ? brand.metaDescription : ""}
        />
      )}
      <PageContentBrand brandMenuData={brandMenuData} brand={brand} showHeader>
        {latestDrop.products.length > 0 && (
          <Box mt={[32, null, 70, null]} mb={[32, null, 80, null]}>
            <LatestDrop title="Latest resale drop" latestDrop={latestDrop} />
          </Box>
        )}

        {categoryPromos.map((category) => {
          let title = category.name;
          if (category.slug === WOMENSWEAR_SLUG && brand.womenswearPromoTitle) {
            title = brand.womenswearPromoTitle;
          }
          if (category.slug === MENSWEAR_SLUG && brand.menswearPromoTitle) {
            title = brand.menswearPromoTitle;
          }
          category.title = title;
          return (
            <Box key={title}>
              <Line />
              <CategoryPromo category={category} brand={brand} />
            </Box>
          );
        })}

        {brand.takebackPromoHeading &&
          brand.takebackPromoText &&
          brand.takebackPromoImage && (
            <BoxWithGutter mt={[32, null, 115, null]} mb={[40, null, 90, null]}>
              <PromoBlock
                heading={brand.takebackPromoHeading}
                text={brand.takebackPromoText}
                ctaLink={brand.takebackUrl}
                ctaText="Learn more"
                externalLink
                image={{
                  src: brand.takebackPromoImage.url,
                  alt: brand.takebackPromoHeading,
                }}
                imagePos={LEFT}
              />
            </BoxWithGutter>
          )}

        {brand.whyPromoHeading && brand.whyPromoText && brand.whyPromoImage && (
          <Why
            heading={brand.whyPromoHeading}
            text={brand.whyPromoText}
            image={{
              src: brand.whyPromoImage.url,
              alt: brand.whyPromoHeading,
            }}
          />
        )}
        {/* <Box mb={[50, null, 155, null]}>
          <SustainabilityStats garments={4305} carbon={2.3} water={213} />
        </Box> */}
        {brand.promoVideoYoutubeId && (
          <BoxWithGutter mt={[40, null, 90, null]} mb={[40, null, 90, null]}>
            <Box maxWidth={1000} mx="auto">
              <YouTubePlayer videoId={brand.promoVideoYoutubeId} />
            </Box>
          </BoxWithGutter>
        )}
        {brand.brandPromoHeading &&
          brand.brandPromoText &&
          brand.brandPromoImage && (
            <BoxWithGutter mt={[40, null, 90, null]} mb={[50, null, 140, null]}>
              <PromoBlock
                heading={brand.brandPromoHeading}
                text={brand.brandPromoText}
                image={{
                  src: brand.brandPromoImage.url,
                  alt: brand.brandPromoHeading,
                }}
                ctaLink={
                  brand.brandPromoLink === "" ? undefined : brand.brandPromoLink
                }
                ctaText="Learn more"
                externalLink
                imagePos={RIGHT}
              />
            </BoxWithGutter>
          )}
      </PageContentBrand>
    </Layout>
  );
}
